/**
 * Central utility for Easy Way Rent a Car links with UTM tracking parameters.
 * Requirements:
 * - Domain: cancunmexico.travel
 * - Parameters:
 *   utm_source=cancunmexico.travel&utm_medium=referral&utm_campaign=sitio-guia&utm_content=<slug de la página en español, sin barras; "inicio" para la portada>
 * - Preserves existing query parameters.
 */

const SITE_DOMAIN = 'cancunmexico.travel';

const SLUG_TO_ES: Record<string, string> = {
  '': 'inicio',
  '/': 'inicio',
  'home': 'inicio',
  'inicio': 'inicio',
  'es': 'inicio',
  'en': 'inicio',
  'pt': 'inicio',
  'rutas': 'rutas',
  'routes': 'rutas',
  'roteiros': 'rutas',
  'eventos': 'eventos',
  'events': 'eventos',
  'festivales': 'eventos',
  'festivals': 'eventos',
  'festivais': 'eventos',
  'consejos-manejo': 'consejos-manejo',
  'driving-guide': 'consejos-manejo',
  'guia-direcao': 'consejos-manejo',
  'consejos': 'consejos-manejo',
  'consejos-viaje': 'consejos-viaje',
  'travel-tips': 'consejos-viaje',
  'dicas-viagem': 'consejos-viaje',
  'viaje': 'consejos-viaje',
};

export function normalizeSpanishSlug(pageSlug?: string): string {
  if (!pageSlug) return 'inicio';
  const clean = pageSlug.split('?')[0].split('#')[0].replace(/^\/+|\/+$/g, '').trim();
  if (!clean || clean === 'es' || clean === 'en' || clean === 'pt') {
    return 'inicio';
  }
  const parts = clean.split('/');
  const lastPart = parts[parts.length - 1];
  return SLUG_TO_ES[lastPart] || SLUG_TO_ES[clean] || lastPart.replace(/^\/+|\/+$/g, '') || 'inicio';
}

export function easywayUrl(url: string, pageSlug?: string): string {
  if (!url) return '';
  const content = normalizeSpanishSlug(pageSlug);

  try {
    const parsed = new URL(url);
    parsed.searchParams.set('utm_source', SITE_DOMAIN);
    parsed.searchParams.set('utm_medium', 'referral');
    parsed.searchParams.set('utm_campaign', 'sitio-guia');
    parsed.searchParams.set('utm_content', content);
    return parsed.toString();
  } catch {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}utm_source=${SITE_DOMAIN}&utm_medium=referral&utm_campaign=sitio-guia&utm_content=${content}`;
  }
}
